import {
    apiRequest,
    salaryDetail
} from "../../../../../services/adapters/master/salaryService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", salaryDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository